/**
 * Иконки нижней навигации (24px, штрих).
 *
 * Вынесены из Layout.tsx вместе со слотами (Ф3 навигации, 2026-07-28):
 * раскладка переехала в navConfig.ts, а конфиг не может ссылаться на
 * компоненты, объявленные внутри Layout. Разметка перенесена ОДИН В ОДИН —
 * толщина штриха по-прежнему меняется на активном слоте.
 */

import type { ReactElement } from "react";

export type NavIconProps = { active?: boolean };
// Тот же тип, что ждёт BottomNav (`icon: (props) => ReactElement`) —
// глобального пространства имён JSX в этой конфигурации TS нет.
export type NavIcon = (props: NavIconProps) => ReactElement;

const BASE = {
  width: 22,
  height: 22,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

export function IconHome({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M3 12l9-9 9 9v9a2 2 0 01-2 2h-4v-7H9v7H5a2 2 0 01-2-2v-9z" />
    </svg>
  );
}

export function IconPlan({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z" />
    </svg>
  );
}

export function IconChart({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M3 3v18h18M7 14l3-3 3 3 5-7" />
    </svg>
  );
}

export function IconTrophy({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M6 4h12v4a6 6 0 0 1-12 0V4z" />
      <path d="M6 6H3a3 3 0 0 0 3 3" />
      <path d="M18 6h3a3 3 0 0 1-3 3" />
      <path d="M10 14h4v3h-4z" />
      <path d="M8 21h8" />
      <path d="M12 17v4" />
    </svg>
  );
}

export function IconUser({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" />
    </svg>
  );
}

export function IconPath({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M5 12h14M5 12c0-4 4-6 7-6s7 2 7 6-4 6-7 6-7-2-7-6zM12 6V3M12 21v-3" />
    </svg>
  );
}

export function IconRace({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M4 21V4M4 4h13l-2.5 4L17 12H4" />
    </svg>
  );
}

/** Форма — состояние организма сейчас. Пульсовая кривая. */
export function IconPulse({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <path d="M3 12h3l2.5-7 4 14 2.5-7H21" />
    </svg>
  );
}

/** Ещё — вход в остальное приложение. */
export function IconMore({ active }: NavIconProps) {
  return (
    <svg {...BASE} strokeWidth={active ? 1.8 : 1.5}>
      <circle cx="5" cy="12" r="1.4" />
      <circle cx="12" cy="12" r="1.4" />
      <circle cx="19" cy="12" r="1.4" />
    </svg>
  );
}
